import { Box, Grid, Typography } from '@material-ui/core';
import SlideFrame, { ContestantHeading } from './SlideFrame';
import BarList from '../tournament/participant/BarList';
import ColumnChart from '../tournament/participant/ColumnChart';
import tagLabel from '../../utils/tagLabels';

// The ratings the two contestants have been solving at, and the tags of what
// they solved.
function DifficultyTagsSlide(props) {
    const sides = [
        { name: props.contestant1, statistics: props.statistics1 },
        { name: props.contestant2, statistics: props.statistics2 }
    ];
    return (
        <SlideFrame eyebrow={props.tournamentName} matchLabel={props.matchLabel} title='Difficulty and Tags'>
            <Grid container spacing={6}>
                {sides.map((side, index) => {
                    const statistics = side.statistics;
                    const solves = (statistics?.difficulty ?? []).reduce((sum, rating) => sum + rating.count, 0);
                    return (
                        <Grid item xs={6} key={index}>
                            <ContestantHeading contestant={index} name={side.name} />
                            {statistics == null ?
                                <Typography color='textSecondary' align='center'> No statistics </Typography> :
                                <>
                                    {/* both charts are held to a column narrower
                                        than the half of the slide they sit in, and
                                        drawn at the size a slide is read at */}
                                    <Box maxWidth={520} margin='0 auto'>
                                        <BarList
                                            large
                                            emptyMessage='No task solved yet'
                                            items={statistics.difficulty.map(rating => ({
                                                key: rating.rating,
                                                label: `${rating.rating}`,
                                                value: rating.count,
                                                valueLabel: solves === 0 ? `${rating.count}` :
                                                    `${rating.count} · ${(rating.count * 100 / solves).toFixed(0)}%`
                                            }))}
                                        />
                                        <Box mt={4}>
                                            <ColumnChart
                                                large
                                                emptyMessage='No tag recorded yet'
                                                items={(statistics.tags ?? []).filter(tag => tag.count !== 0).slice(0, 6).map(tag => ({
                                                    key: tag.tag,
                                                    label: tagLabel(tag.tag),
                                                    value: tag.count,
                                                    valueLabel: `${tag.count} / ${tag.occurrences}`
                                                }))}
                                            />
                                        </Box>
                                    </Box>
                                </>
                            }
                        </Grid>
                    );
                })}
            </Grid>
        </SlideFrame>
    );
}

export default DifficultyTagsSlide;
